import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { IntegrationSettings } from "../types";

async function getIntegrationSettings(
  workspaceId: string,
): Promise<IntegrationSettings> {
  return (await get(`workspaces/${workspaceId}/integrations`)).integrations;
}

export default function useIntegrationSettings() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data: integrationSettings, isLoading: isLoadingIntegrationSettings } =
    useQuery({
      queryKey: getQueryKeys(workspaceId).integrationSettingsKey,
      queryFn: () => getIntegrationSettings(workspaceId),
    });

  return { integrationSettings, isLoadingIntegrationSettings };
}
